/*
 * Copyright (c) 2023 by Allen_sun email: Allen_sun_js@hotmail.com, All Rights Reserved.
 */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// import Element from 'element-ui'
import ElementPlus from "element-plus";
import "element-plus/lib/theme-chalk/index.css";
import "@/icons";
import SvgIcon from "@/components/SvgIcon"; // svg组件
import zjSDK from "./assets/xc_vs_zj_mid_sdk/xc_vs_zj_mid_sdk.js";
import { getRole } from "@/utils/utils";
import axiosIns from "./utils/request";
router.beforeEach((to, from, next) => {
  // 修改标题名称
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 非登录页面 没有登录信息时，跳转至登录页面
  const s_loginInfo = sessionStorage.getItem("loginInfo");
  const l_loginInfo = localStorage.getItem("loginInfo");
  var loginInfo;
  if (s_loginInfo) {
    loginInfo = s_loginInfo;
  } else {
    loginInfo = l_loginInfo;
  }

  if (loginInfo) {
    if (to.path == "/login") {
      const role = getRole();
      return role == "teacher"
        ? next("/teachlogin")
        : role == "student"
        ? next("/studentlogin")
        : (() => {
            localStorage.clear();
            sessionStorage.clear();
            next("/login");
          })();
    }
  } else {
    if (to.path !== "/login") {
      return next("/login");
    }
  }

  // 以下代码 屎一样 啥时候改改
  if (localStorage.getItem("loginInfo")) {
    sessionStorage.setItem("loginInfo", localStorage.getItem("loginInfo"));
  }
  if (localStorage.getItem("access_token")) {
    sessionStorage.setItem(
      "access_token",
      localStorage.getItem("access_token")
    );
  }
  if (localStorage.getItem("role")) {
    sessionStorage.setItem("role", localStorage.getItem("role"));
  }

  next();
});

const app = createApp(App);
app.use(router).use(ElementPlus).use(zjSDK).mount("#app");
app.config.globalProperties.$http = axiosIns;
app.component("svg-icon", SvgIcon);
